/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types'
import React from 'react'
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps'
import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import ICONS from 'components/common/icon/const'
import env from 'config/env'
import { MAP_VALUES_SG, MAP_VALUES_TH } from './const'
import styles from './style.scss'

class GoogleMapLocation extends React.PureComponent {
  getMapValues(country) {
    switch (country) {
      case 'sg':
        return MAP_VALUES_SG
      default:
        return MAP_VALUES_TH
    }
  }

  getLatitude() {
    const { selectedLocation, isPhone, country, searchedLocation } = this.props

    const mapValues = this.getMapValues(country)

    let latitudeValue = mapValues.latitude_w

    if (isPhone && !searchedLocation && !selectedLocation) {
      latitudeValue = mapValues.latitude_wm
    } else if (searchedLocation && searchedLocation.latitude) {
      latitudeValue = searchedLocation.latitude
    } else if (selectedLocation && selectedLocation.latitude) {
      latitudeValue = selectedLocation.latitude
    }

    return latitudeValue
  }

  getLongitude() {
    const { selectedLocation, isPhone, country, searchedLocation } = this.props

    const mapValues = this.getMapValues(country)
    let longitudeValue = mapValues.longitude_w

    if (isPhone && !searchedLocation && !selectedLocation) {
      longitudeValue = mapValues.longitude_wm
    } else if (searchedLocation && searchedLocation.longitude) {
      longitudeValue = searchedLocation.longitude
    } else if (selectedLocation && selectedLocation.longitude) {
      longitudeValue = selectedLocation.longitude
    }

    return longitudeValue
  }

  getMapZoomValue() {
    const {
      selectedLocation,
      filteredLocations,
      searchedLocation,
      country,
      isPhone,
    } = this.props
    const mapValues = this.getMapValues(country)

    let zoomLevel = mapValues.zoom
    if (
      isPhone &&
      !selectedLocation &&
      !filteredLocations?.length &&
      !searchedLocation
    ) {
      zoomLevel = mapValues.zoom_mbl
    } else if (
      searchedLocation &&
      searchedLocation.longitude &&
      searchedLocation.latitude
    ) {
      zoomLevel = 12
    } else if (filteredLocations && filteredLocations.length > 0) {
      zoomLevel = 12
    } else if (
      selectedLocation &&
      selectedLocation.longitude &&
      selectedLocation.latitude
    ) {
      zoomLevel = 13
    }

    return zoomLevel
  }

  handleOnMarkerClick = (data) => {
    const { setSelectedLocation } = this.props

    if (!data.isCurrentLocation) {
      setSelectedLocation(data)
    }
  }

  renderGoogleMapMarker = (data) => {
    const markerPosition = {
      lat: parseFloat(data.latitude),
      lng: parseFloat(data.longitude),
    }

    const markerOptions = {
      icon: {
        url: ICONS.pickUpMarker,
        scaledSize: new window.google.maps.Size(80, 80),
      },
    }

    return (
      <Marker
        position={markerPosition}
        onClick={() => this.handleOnMarkerClick(data)}
        options={markerOptions}
        ariaLabel={data.alias}
        data-iscurrent={!!data.isCurrentLocation}
        key={`${data.alias}-${data.latitude}-${data.longitude}`}
      />
    )
  }

  render() {
    const { locations, filteredLocations, currentLocation } = this.props

    let mapLocations = filteredLocations || locations

    let currentLocationObj = []
    if (currentLocation) {
      currentLocationObj = [
        {
          latitude: currentLocation.latitude,
          longitude: currentLocation.longitude,
          isCurrentLocation: true,
        },
      ]

      mapLocations = [...currentLocationObj, ...mapLocations]
    }

    const KEY = env.GOOGLE_API_KEY
    const latitude = this.getLatitude()
    const longitude = this.getLongitude()
    const defaultZoomValue = this.getMapZoomValue()

    const containerElement = (
      <div
        style={{ height: '100%', width: '100%', minHeight: '300px' }}
        id="google_map_script"
      />
    )

    const StyledMapWithAnInfoBox = compose(
      withProps({
        googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${KEY}&libraries=places`,
        loadingElement: containerElement,
        containerElement,
        mapElement: containerElement,
        center: { lat: latitude, lng: longitude },
      }),
      withScriptjs,
      withGoogleMap,
    )((props) => (
      <GoogleMap
        defaultZoom={defaultZoomValue}
        defaultCenter={props.center}
        defaultOptions={{
          disableDefaultUI: false,
          mapTypeControl: false,
          scaleControl: false,
          fullscreenControl: false,
          streetViewControl: false,
        }}
      >
        {mapLocations && mapLocations.map(this.renderGoogleMapMarker)}
      </GoogleMap>
    ))

    return (
      <div
        className="google-map-location-component"
        id="google-map-location-component"
      >
        <style jsx>{styles}</style>
        <StyledMapWithAnInfoBox />
      </div>
    )
  }
}

GoogleMapLocation.defaultProps = {
  country: '',
  currentLocation: null,
  filteredLocations: [],
  isPhone: true,
  selectedLocation: null,
  searchedLocation: null,
}

GoogleMapLocation.propTypes = {
  country: PropTypes.string,
  currentLocation: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  filteredLocations: PropTypes.arrayOf(PropTypes.shape({})),
  internationalization: PropTypes.shape({}).isRequired,
  isPhone: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchedLocation: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  selectedLocation: PropTypes.shape({
    id_partner_store: PropTypes.number,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  setSelectedLocation: PropTypes.func.isRequired,
}

export { GoogleMapLocation }

export default connect(
  /* istanbul ignore next */
  (state) => ({
    isPhone: state.device.isPhone,
    internationalization: state.internationalization,
  }),
)(GoogleMapLocation)
